<div *ngIf="finished==false" class='text-center'>
  <svg width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling"
    style="background: none;">
    <circle cx="50" cy="50" fill="none" stroke="#28a745" stroke-width="7" r="35"
      stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(346.659 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
        keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
    </circle>
  </svg>
</div>

<div *ngIf="no_recfound" class="text-center">
  {{mls?.languageText?.doctalk?.key1}}<span *ngIf="mls?.is_lskey_display==1">(doctalk.key1)</span>
</div>


<div *ngIf="is_res_received && no_recfound==false" class="mt-2 position-relative mb-2 cursor-pointer"
  (click)="navigateto()"
  [eventTracker]='{"category":"web_share","action":"click_on_doctalk","product_type":product_type,"product_id":product_type_id}'>
  <div class="bg-white rounded overflow-hidden">
    <img src={{doctalkDetail?.media[0]?.media_thumbnail}} class="w-100 doctlk-dtls-top-img post-pic"
      onerror="this.src='assets/img/image_placeholder.svg'" />

    <div class="w-100 h-100 p-3 doctlk-dtls-top fnt-size14px text-very-dark">

      <p class="fnt-size18px mb-2"><b>{{doctalkDetail?.title}} </b></p>
      <p class="fnt-size14px fnt-weight500 mb-2"><span
          class="clinical-compny mr-4 position-relative">{{doctalkDetail?.views}}
          {{mls?.languageText?.doctalk?.key3}}<span *ngIf="mls?.is_lskey_display==1">(doctalk.key3)</span></span><span
          class="clinical-compny mr-4 position-relative">{{playTime}} {{mls?.languageText?.doctalk?.key2}}<span
            *ngIf="mls?.is_lskey_display==1">(doctalk.key2)</span></span></p>


      <p *ngIf="doctalkDetail?.channel?.pharma_classification!='pharma'" class="fnt-size14px mb-2 light-font">
        {{doctalkDetail?.description }}
        <span style="cursor:pointer; color:#ba0000" *ngIf="doctalkDetail?.description.length>230"></span>
      </p>

      <div *ngIf="doctalkDetail?.channel?.pharma_classification=='pharma'">
        <h3 class=" text-center mt-4">{{mls?.languageText?.doctalk?.key4}}<span
            *ngIf="mls?.is_lskey_display==1">(doctalk.key4)</span></h3>
      </div>


      <p class="fnt-size12px mb-2 text-medium-grey">{{mls?.languageText?.doctalk?.key5}}<span
          *ngIf="mls?.is_lskey_display==1">(doctalk.key5)</span></p>
      <!-- speakers card -->
      <div class="row m-0">
        <div class="float-left mr-2 col-2 p-0" style="min-width: 40px; max-width: 40px;">
          <img src={{doctalkDetail?.speaker[0]?.profile_pic}} class="post-pic user-40 rounded-circle"
            onerror="this.src='assets/img/image_placeholder.svg'" />
        </div>
        <div class="float-left col-10 p-0" style="max-width: calc(100% - 51px);">
          <p class="fnt-size14px"><b>{{doctalkDetail?.speaker[0]?.name}}</b></p>
        </div>
      </div>
      <!-- end card -->
      <div class="play-vide-doctlk">
        <button class="btn btn-success w-100 pt-2 pb-2 mt-4 mb-3">{{mls?.languageText?.doctalk?.key6}}<span
            *ngIf="mls?.is_lskey_display==1">(doctalk.key6)</span></button>
        <div class="row text-center">
          <div class="col-4">
            <button class="btn border fnt-weight500 w-100 pt-2 pb-2 pl-1 pr-1 fnt-size12px">

              <svg style="margin-top:-4px" width="18px" viewBox="0 0 16 16">
                <defs>
                  <style>
                    .dtls-lyk-card {
                      fill: var(--very-dark-color);
                    }
                  </style>
                </defs>
                <g id="Layer_3" data-name="Layer 3">
                  <path class="dtls-lyk-card"
                    d="M4.53,13.74h.79l.66.7a2.39,2.39,0,0,0,1.73.76l4.34.07a2.1,2.1,0,0,0,2-1.6,1.55,1.55,0,0,0-.12-1s1.57-1.57.52-2.88a1.35,1.35,0,0,0,1-1.37,2.27,2.27,0,0,0-2.28-2.3H10V3.69A3,3,0,0,0,8.15.87L8,.8a.78.78,0,0,0-1.08.72V3.6a1.54,1.54,0,0,1-.2.76l-1,1.73a.52.52,0,0,1-.46.27H4.53" />
                  <path class="dtls-lyk-card"
                    d="M2.71,14.63h0A2.19,2.19,0,0,1,.5,12.44v-5a2.2,2.2,0,0,1,4.4,0v5A2.19,2.19,0,0,1,2.71,14.63Zm0-8.69A1.47,1.47,0,0,0,1.23,7.4v5a1.45,1.45,0,0,0,1.45,1.45h0a1.46,1.46,0,0,0,1.46-1.45v-5A1.47,1.47,0,0,0,2.71,5.94Z" />
                </g>
              </svg> {{mls?.languageText?.doctalk?.key7}}<span
                *ngIf="mls?.is_lskey_display==1">(doctalk.key7)</span></button>
          </div>
          <div class="col-4 p-0">
            <button class="btn border fnt-weight500 w-100 pt-2 pb-2 pl-1 pr-1 fnt-size12px">

              <svg width="20px" id="Layer_ bookmarked" data-name="Layer  bookmarked" viewBox="0 0 15 15">
                <defs>
                  <style>
                    .dtls-bookmark-card {
                      fill: var(--very-dark-color);
                    }
                  </style>
                </defs>
                <path class="dtls-bookmark-card"
                  d="M11.54,12.84l-4-3.06-4,3.06v-10a.65.65,0,0,1,.65-.65h6.78a.65.65,0,0,1,.65.65Z" />
              </svg>

              {{mls?.languageText?.doctalk?.key8}}<span *ngIf="mls?.is_lskey_display==1">(doctalk.key8)</span>
            </button>
          </div>
          <div class="col-4">
            <button class="btn border fnt-weight500 w-100 pt-2 pb-2 pl-1 pr-1 fnt-size12px"> <svg width="20px"
                viewBox="0 0 16 16">
                <defs>
                  <style>
                    .dtls-shre-card {
                      fill: var(--very-dark-color);
                    }
                  </style>
                </defs>
                <g id="Layer_3" data-name="Layer 3">
                  <path class="dtls-shre-card"
                    d="M9.5,13.2V9.92C5.33,9.92,2.58,11.2.5,14c.84-4,3.16-8,9-8.8V2l6,5.59Z" />
                </g>
              </svg> {{mls?.languageText?.doctalk?.key9}}<span
                *ngIf="mls?.is_lskey_display==1">(doctalk.key9)</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>